var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"up"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"up-img",attrs:{"src":require("img/indexImg/020.png")},on:{"click":_vm.webUp}})])
}
var staticRenderFns = []

export { render, staticRenderFns }